import { Injectable } from '@angular/core';
import { RouterService, Skill, Utils } from '@mitel/cloudlink-sdk';
import { TranslateService } from '@ngx-translate/core';
import { from, Observable, of, Subscription } from 'rxjs';
import { catchError, publishReplay, refCount, tap, shareReplay } from 'rxjs/operators';


@Injectable({
    providedIn: 'root',
})
export class SkillsService {

    private cache: { [key: string]: Observable<Skill> } = {};

    private skillsForAccountObservable;
	private skillsForAccount;

    private acctCacheSubscription: Subscription = new Subscription();
  
    constructor(
        private translateService: TranslateService,
        private routerService: RouterService )
    {
    }

    getCachedAccountSkills(): Promise<Skill[]> 
	{
		return new Promise<Skill[]> ( (resolve, reject) => {
			if ( this.skillsForAccount != undefined )
			{
				return resolve(this.skillsForAccount);
			}
			else
			{
				// no cache, get a fresh list
				if ( this.skillsForAccountObservable == undefined )
				{
					this.skillsForAccountObservable = this.getAccountSkillsObservable();
				}
				this.acctCacheSubscription.add(this.skillsForAccountObservable.subscribe(skills => {
					this.skillsForAccount = skills;
					return resolve(skills);
				}));
			}

		});
	}
	private getAccountSkillsObservable(): Observable<Skill[]>
	{
		return Observable.create( async (observer) => {
			let acctSkills: Skill[] = undefined;
            return this.routerService.getSkills({ $Top: 1000 }).then( response => {
                const acctSkills = Utils.getItemsFromCollection(response);
				return observer.next(acctSkills);
			})
			.catch( err => {
				//we will log and return an empty list
				console.error("There was an error requesting the acct skills", err);
				return observer.next(acctSkills);
			});
		})
		.pipe(
			shareReplay()
		);
	}

    public clearAccountSkillsCache()
    {
        this.acctCacheSubscription.unsubscribe();
		this.acctCacheSubscription = new Subscription();
		this.skillsForAccountObservable = undefined;
		this.skillsForAccount = undefined;
    }

    getSkill(skillId: string): Observable<Skill> {
        this.cache[skillId] = this.cache[skillId] || this.fetchSkill(skillId);
        return this.cache[skillId];
    }

    private fetchSkill(skillId: string): Observable<Skill> {
        return from(this.routerService.getSkill({ skillId: skillId }))
            .pipe(
                publishReplay(1), // this tells Rx to cache the latest emitted
                refCount(), // and this tells Rx to keep the Observable alive as long as there are any Subscribers
                catchError(e => {
                    const empty: any = {
                        name: this.translateService.instant('app.misc.unknown'),
                        skillId: 'unknown',
                    }
                    return of(empty);
                })
            );
    }

}